import { AnyAction } from 'redux';
import { Injectable } from '@angular/core';
import { TARIF_CHECKED } from '@ps20-frontend/shop-integration-redux';
import { Selbstbeteiligung } from '@ps20/bff-models';
import { IAppState } from './appState';
import { AntragsummerGenerated } from './action-types/antragsummerGenerated';
import { GegenstandsschutzItem } from './reducers/gegenstandsschutz.reducer';

export interface GegeAction<T = undefined> extends AnyAction {
  payload?: T;
}

@Injectable()
export class GegeActions {
  static readonly ANTRAGSNUMMER_GENERATED = 'ANTRAGSNUMMER_GENERATED';
  static readonly ZURUECK_ZUM_SHOP_MODAL_OPEN = 'ZURUECK_ZUM_SHOP_MODAL_OPEN';
  static readonly ZURUECK_ZUM_SHOP_MODAL_CLOSE = 'ZURUECK_ZUM_SHOP_MODAL_CLOSE';
  static readonly SELBSTBETEILIGUNG_CHANGED = 'SELBSTBETEILIGUNG_CHANGED';
  static readonly VORSCHLAGDATEN_CHANGED = 'VORSCHLAGDATEN_CHANGED';
  static readonly ABSPRUNG_INS_DASHBOARD = 'ABSPRUNG_INS_DASHBOARD';
  static readonly GEGENSTAENDE_ADDED = 'GEGENSTAENDE_ADDED';
  static readonly GEGENSTAENDE_VORBELEGT = 'GEGENSTAENDE_VORBELEGT';
  static readonly GEGENSTAND_REMOVED = 'GEGENSTAND_REMOVED';
  static readonly PREISE_REQUESTED = 'PREISE_REQUESTED';
  static readonly ZUM_ANGEBOT_BUTTON_CLICKED = 'ZUM_ANGEBOT_BUTTON_CLICKED';
  static readonly FAHRRAD_VORSCHAEDEN_VORHANDEN_CHANGED = 'FAHRRAD_VORSCHAEDEN_VORHANDEN_CHANGED';
  static readonly FAHRRAD_VORSCHAEDEN_COUNT_CHANGED = 'FAHRRAD_VORSCHAEDEN_COUNT_CHANGED';
  static readonly HANDLE_GEGE_NAVIGATION_TO_ANGEBOT = 'HANDLE_GEGE_NAVIGATION_TO_ANGEBOT';

  antragsnummerGenerated(
    antragsnummer: IAppState['antragsnummer'],
    angebotsId: IAppState['angebotsId'],
  ): GegeAction<AntragsummerGenerated> {
    return {
      type: GegeActions.ANTRAGSNUMMER_GENERATED,
      payload: { antragsnummer, angebotsId },
    };
  }

  zurueckZumShopModalOpen(): GegeAction<void> {
    return { type: GegeActions.ZURUECK_ZUM_SHOP_MODAL_OPEN };
  }

  zurueckZumShopModalClose(): GegeAction<void> {
    return { type: GegeActions.ZURUECK_ZUM_SHOP_MODAL_CLOSE };
  }

  selbstbeteiligungChanged(selbstbeteiligung: Selbstbeteiligung): GegeAction<Selbstbeteiligung> {
    return {
      type: GegeActions.SELBSTBETEILIGUNG_CHANGED,
      payload: selbstbeteiligung,
    };
  }

  vorschlagdatenChanged(angebotsId: string): GegeAction<string> {
    return { type: GegeActions.VORSCHLAGDATEN_CHANGED, payload: angebotsId };
  }

  absprungInsDashboard(): GegeAction<void> {
    return { type: GegeActions.ABSPRUNG_INS_DASHBOARD };
  }

  tarifChecked(index: number): GegeAction<{ index: number }> {
    return { type: TARIF_CHECKED, payload: { index } };
  }

  preiseRequested(): GegeAction {
    return { type: GegeActions.PREISE_REQUESTED };
  }

  gegenstaendeAdded(gegenstaende: GegenstandsschutzItem[]): GegeAction<GegenstandsschutzItem[]> {
    return { type: GegeActions.GEGENSTAENDE_ADDED, payload: gegenstaende };
  }

  gegenstaendeVorbelegt(
    gegenstaende: GegenstandsschutzItem[],
    angebotsId: string,
  ): GegeAction<{ gegenstaende: GegenstandsschutzItem[]; angebotsId: string }> {
    return {
      type: GegeActions.GEGENSTAENDE_VORBELEGT,
      payload: { gegenstaende, angebotsId },
    };
  }

  gegenstandRemoved(id: string): GegeAction<{ id: string }> {
    return { type: GegeActions.GEGENSTAND_REMOVED, payload: { id } };
  }

  fahrradVorschaedenVorhanden(value: boolean): GegeAction<{ provided: boolean }> {
    return {
      type: GegeActions.FAHRRAD_VORSCHAEDEN_VORHANDEN_CHANGED,
      payload: { provided: value },
    };
  }

  fahrradVorschaedenCountChanged(value: number): GegeAction<{ value: number }> {
    return { type: GegeActions.FAHRRAD_VORSCHAEDEN_COUNT_CHANGED, payload: { value } };
  }

  handleGegeNavigationToAngebot(): GegeAction {
    return { type: GegeActions.HANDLE_GEGE_NAVIGATION_TO_ANGEBOT };
  }

  zumAngebotButtonClicked(): GegeAction {
    return { type: GegeActions.ZUM_ANGEBOT_BUTTON_CLICKED };
  }
}

const _gegeActions = new GegeActions();
export type AntragsnummerGeneratedAction = ReturnType<typeof _gegeActions.antragsnummerGenerated>;
export type SelbstbeteiligungChangedVorvertragAction = ReturnType<
  typeof _gegeActions.selbstbeteiligungChanged
>;
export type TarifCheckedAction = ReturnType<typeof _gegeActions.tarifChecked>;
export type GegenstaendeVorbelegtAction = ReturnType<typeof _gegeActions.gegenstaendeVorbelegt>;
